import PropTypes from 'prop-types';

const TOPICS = [
	'parameters',
	'outputs',
	'inputs'
];

export default {
	topic: PropTypes.oneOf(TOPICS),
	selectedNode: PropTypes.shape({
		id: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]).isRequired,
		type: PropTypes.oneOf([
			'start',
			'flow-node',
			'trigger',
			'endpoint'
		]).isRequired,
		topic: PropTypes.oneOf(TOPICS).isRequired,
		options: PropTypes.any
	}),
	flowTriggers: PropTypes.shape({
		definitions: PropTypes.object,
		triggersInfo: PropTypes.shape({
			endpoints: PropTypes.array,
			triggers: PropTypes.object
		})
	}),
	triggerDefinitions: PropTypes.object
};
